import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useRutas } from "@/components/RutaHormaCampos";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Cambiar la ruta de un modelo ya creado: solo SuperAdmin y con motivo (14-oct-2026).
export default function CambiarRutaDialog({ open, onOpenChange, modelo, onCambiada }) {
  const rutas = useRutas();
  const [ruta, setRuta] = useState("");
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  const actual = modelo?.ruta_info?.id;

  useEffect(() => { if (open) { setRuta(actual || ""); setMotivo(""); } }, [open, actual]);

  const nueva = rutas.find((r) => r.id === ruta);
  const guardar = async () => {
    setBusy(true);
    try {
      await api.post(`/modelos/${modelo.id}/ruta`, { ruta, motivo: motivo.trim() });
      toast.success("Ruta cambiada");
      onOpenChange(false);
      onCambiada?.();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cambiar ruta de desarrollo</DialogTitle>
          <DialogDescription>
            Cambia qué compuertas sigue el modelo. Los pasos ya hechos se conservan; los nuevos quedan pendientes. Queda en el historial con el motivo.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label>Ruta</Label>
          <Select value={ruta} onValueChange={setRuta}>
            <SelectTrigger data-testid="cambiar-ruta-select"><SelectValue placeholder="Elige la ruta" /></SelectTrigger>
            <SelectContent>
              {rutas.map((r) => <SelectItem key={r.id} value={r.id}>{r.nombre} · {r.total} pasos{r.id === actual ? " (actual)" : ""}</SelectItem>)}
            </SelectContent>
          </Select>
          {nueva && !nueva.horma_en_paso && !modelo?.horma && (
            <p className="text-[11px] text-amber-700">Esta ruta usa una horma existente: después de cambiarla, elige la horma del modelo.</p>
          )}
        </div>
        <div className="space-y-1.5">
          <Label>Motivo (mínimo 10 caracteres)</Label>
          <Textarea rows={3} value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ej. el cliente pidió cambiar a sintético" data-testid="cambiar-ruta-motivo" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={guardar} disabled={busy || !ruta || ruta === actual || motivo.trim().length < 10} data-testid="cambiar-ruta-confirmar">Cambiar ruta</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
